<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaLocalidades"
    :search="search"
    :no-data-text="'Este projeto não possui localidades.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.nome="props">
        <div v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true">
          <router-link :to="{ name: 'EditarLocalidade', params: { idProjeto: idProjeto, idLocalidade: props.item.id }}">
            {{ props.item.nome }}
          </router-link>
        </div>
        <div v-else>
          {{ props.item.nome }}
        </div>
      </template>
      <template v-slot:item.opcoes="props">
        <v-btn v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true" color="primary" text icon @click="excluirLocalidade(props.item.id)" >
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaLocalidades.length }} localidades
      </template>
    </v-data-table>
    <br><br>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="ArquivosProjeto"
      editar="NovaLocalidade"
      nome_editar="Nova Localidade"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
      <v-btn color="primary" text @click="toLimparLocalidades" >Limpar</v-btn>
    </c-card-footer>
  </div>
</template>

<script>
import CardFooter from '@/components/c-card-footer'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    listaLocalidades: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome da localidade ou instituição', align: 'left', value: 'nome' },
      { text: 'Estado', align: 'left', value: 'ufCidade.descricao' },
      { text: 'Município', align: 'left', value: 'cidade.nomeCidade' },
      { text: 'CEP', align: 'left', value: 'cep' },
      { text: 'Informações adicionais', align: 'left', value: 'detalhes' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toLimparLocalidades: function () {
      if (confirm('Deseja realmente exluir todas as localidades cadastradas?')) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' })
        this.listaLocalidades.forEach(item => {
          this.excluirLocalidade(item.id)
        })
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' })
      }
    },
    carregaLocalidades: function (idProjeto) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' })
      projetos.getListaLocalidade(this.idProjeto)
      .then(response => {
        this.listaLocalidades = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' })
      })
    },
    excluirLocalidade: function (idLocalidade) {
      projetos.deleteLocalidade(this.idProjeto, idLocalidade)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaLocalidades(this.idProjeto)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
      })
    }
  },
  mounted () {
    this.carregaLocalidades(this.idProjeto)
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-abrangencia-tabela.vue?dd402536